<script>

export default {
  name: 'ItemLink',
  props: {
    item: {
      type: Object,
      required: true
    },
  }
}
</script>
<template>
  <router-link :to="item.link" class="btn-link">
    <span class="icon" v-if="item.icon">
      <img :src="require(`@/assets/images/icons/${item.icon}`)"></span> {{ item.label }} ({{ item.count }} items)
  </router-link>
</template>